import axios from "axios";
import Config from "../utils/Config";

class AuthService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_agt_tk")}`,
      },
    };
  }

  async register(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/register`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Registration successful!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Registration failed!",
        data: null,
      };
    }
  }

  async verifyAccount(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/verify/account`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason || "Account verification successful!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Account verification failed!",
        data: null,
      };
    }
  }

  async resendVerificationCode(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/resend/verificationCode`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason || "Verification code resend successful!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Verification code resend failed!",
        data: null,
      };
    }
  }

  async login(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/login`,
        payload,
        this.getHeaders()
      );
      if (response.data?.data?.status_code === 200) {
        return {
          status: true,
          message: response.data.data?.reason || "Login successful!",
          data: response.data.data,
          user: response.data.data.data,
          token: response.data.data.data.token,
        };
      } else {
        return {
          status: false,
          message: response.data.data?.reason || "Login failed!",
          data: null,
        };
      }
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Login failed!",
        data: null,
      };
    }
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/update/profile`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Profile updated successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason || "Profile update failed!",
        data: null,
      };
    }
  }

  async changePassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/change/password`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Password changed successfully!",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason || "Password change failed!",
      };
    }
  }

  async forgotPassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/send/resetpassword/otp`,
        payload,
        this.getHeaders()
      );

      // Check if the response indicates success based on the API response format
      if (
        response.data?.data?.status_code === 200 &&
        response.data?.data?.message === "Action Successful"
      ) {
        return {
          status: true,
          data: response.data,
          message:
            response.data.data?.reason || "Reset code sent successfully!",
        };
      } else {
        return {
          status: false,
          data: response.data,
          message: response.data.data?.reason || "Failed to send reset code",
        };
      }
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Reset code sent failed!",
      };
    }
  }

  async resetPassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/resetpassword`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data.data?.reason || "Reset password successfully!",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Reset password failed!",
      };
    }
  }
}
const authService = new AuthService();
export default authService;
